<div class="form-group">
    <p-toggleswitch
        [inputId]="id() + '-toggle-switch'"
        [formControl]="control()"
        [invalid]="control().invalid && (control().dirty || control().touched)"
        (onChange)="onChange.emit($event)">
    </p-toggleswitch>

    @if (label()) {
        <form-label
            [id]="id() + '-label'"
            [forId]="id() + '-toggle-switch'"
            [label]="label()"
            [required]="required()"
            [tooltipText]="tooltipText()"></form-label>
    }
</div>
